import React from 'react';
import RecommendedProducts from './RecommendedProducts';

/**
 * Wrapper component for displaying related products
 * "Customers who bought this also bought..."
 */
const RelatedProducts = ({ productId, limit = 8 }) => {
  if (!productId) return null;

  return (
    <div className="border-t pt-8 mt-8">
      <RecommendedProducts 
        type="related" 
        productId={productId} 
        limit={limit}
      />
    </div>
  );
};

export default RelatedProducts;

